import React from 'react';
import { Link } from 'react-router-dom';

const ShippingPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Shipping & Delivery Policy</h1>
          <p className="text-gray-600">Last updated on Oct 10 2025</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-md p-8 space-y-6">
          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within <strong>Not Applicable</strong> or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>NEHA KEDAR KHAPARE</strong> is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within <strong>Not Applicable</strong> from the date of the order and payment or as per the delivery date agreed at the time of order confirmation.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed">
              For any issues in utilizing our services you may contact our helpdesk on <strong>8554903120</strong> or <a href="mailto:neha.khapare1989@gmail.com" className="text-indigo-600 hover:text-indigo-700 font-medium">neha.khapare1989@gmail.com</a>
            </p>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-6 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700 font-semibold"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
